import { render, staticRenderFns } from "./DynamicIsland.vue?vue&type=template&id=8d942f7a&scoped=true"
import script from "./DynamicIsland.vue?vue&type=script&lang=js"
export * from "./DynamicIsland.vue?vue&type=script&lang=js"
import style0 from "./DynamicIsland.vue?vue&type=style&index=0&id=8d942f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d942f7a",
  null
  
)

export default component.exports